// src/pages/SuperAdmin/Dashboard.jsx - FIXED
import React, { useState, useEffect } from 'react';
import { Users, ChefHat, TrendingUp, Loader } from 'lucide-react';
import StorageService from '../../services/StorageService';

const SuperAdminDashboard = () => {
  const [data, setData] = useState({
    restaurants: [],
    packages: [],
    superadmin: {},
    customerSessions: {}
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
         
        
        const result = await StorageService.getData();
        
        console.log('📊 Dashboard: Data received:', {
          restaurants: result.restaurants?.length || 0,
          packages: result.packages?.length || 0
        });
        
        setData({
          restaurants: result.restaurants || [],
          packages: result.packages || [],
          superadmin: result.superadmin || {},
          customerSessions: result.customerSessions || {}
        });
        setError(null);
      } catch (err) {
        console.error('❌ Dashboard fetch error:', err);
        setError('Failed to load dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="p-6 flex items-center justify-center min-h-screen">
        <div className="text-center">
          <Loader className="w-12 h-12 text-orange-500 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-700">{error}</p>
        </div>
      </div>
    );
  }

  const activeRestaurants = data.restaurants.filter(r => r.status === 'Active').length;
  const totalSales = data.restaurants.reduce((sum, r) =>
    sum + (r.orders || []).reduce((s, o) => s + (o.total || 0), 0), 0
  );

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {/* Total Restaurants */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm mb-1">Total Restaurants</p>
              <p className="text-3xl font-bold text-gray-800">{data.restaurants.length}</p>
            </div>
            <div className="bg-blue-100 p-4 rounded-full">
              <ChefHat className="w-8 h-8 text-blue-600" />
            </div>
          </div>
        </div>

        {/* Active Restaurants */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm mb-1">Active Restaurants</p>
              <p className="text-3xl font-bold text-green-600">{activeRestaurants}</p>
            </div>
            <div className="bg-green-100 p-4 rounded-full">
              <Users className="w-8 h-8 text-green-600" />
            </div>
          </div>
        </div>

        {/* Total Sales */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm mb-1">Total Sales</p>
              <p className="text-3xl font-bold text-orange-600">₹{totalSales}</p>
            </div>
            <div className="bg-orange-100 p-4 rounded-full">
              <TrendingUp className="w-8 h-8 text-orange-600" />
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Recent Activity</h2>
        {data.restaurants.length > 0 ? (
          <div className="space-y-3">
            {data.restaurants.slice(0, 5).map(restaurant => (
              <div key={restaurant.id} className="flex items-center justify-between border-b pb-3 last:border-b-0">
                <div>
                  <p className="font-semibold text-gray-800">{restaurant.name}</p>
                  <p className="text-sm text-gray-600">
                    {(restaurant.orders || []).length} orders · {(restaurant.menu || []).length} menu items
                  </p>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                  restaurant.status === 'Active' 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-red-100 text-red-700'
                }`}>
                  {restaurant.status}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-8">No restaurants yet</p>
        )}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;